import React, { Suspense } from "react";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import ReleaseGrid from "../components/release/ReleaseGrid";
import ReleaseStats from "../components/release/ReleaseStats";

import "../styles/release.css";
import StatSkeleton from "../components/common/StatSkeleton";
import CreateReleaseTile from "../components/release/CreateReleaseTile";

export default function Releases() {
  return (
    <div className="fragmentContainer">
      <Grid container spacing={2}>
        <Suspense fallback={<StatSkeleton />}>
          <ReleaseStats />
        </Suspense>
        <CreateReleaseTile />
        <Grid item xs={12} md={12}>
          <Card>
            <CardContent
              sx={{
                padding: 0,
                ":last-child": {
                  padding: 0,
                },
              }}
            >
              <ReleaseGrid tableTitle="Available Releases" />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
